
import { Options, Vue } from "vue-class-component";

import zxcvbn from 'zxcvbn-typescript';

//
// two ways binding 
// https://www.digitalocean.com/community/tutorials/how-to-add-v-model-support-to-custom-vue-js-components
@Options({
  props: {
    label: {
      default: "",
      required: true,
      type: String,
    },
    value: {
      type: String,
    },
  },
})
export default class Password extends Vue {
  score = 0;
  label!: string;
  value!: string;

  get password() {
    return this.value;
  }
  set password(value) {
    this.score = zxcvbn(value||'').score;
    this.$emit('value', value);   
    this.$emit('score', this.score);   
  }
}
